import "design/businessCss/businessHeader.css";
import CustomBreadCrumbs from "design/common/customBreadCrumbs";
import { useTranslation } from "react-i18next";
const HeaderBackground = (props: any) => {
  const { route } = props;
  const { t } = useTranslation();
  return (
    <div className={"business-container"}>
      <div className={"business-header-image"}>
        <div className={"business-header-image-navi"}>
          <CustomBreadCrumbs routes={route} />
        </div>
      </div>
    </div>
  );
};
export default HeaderBackground;
